import { Component, inject, OnInit } from '@angular/core';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DimensionsService } from 'src/app/_services/images/dimensions.service';
import { unitList } from 'src/assets/config/constants';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/_services/common/common.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AuthServiceUser } from 'src/app/services/auth/auth.service';
import { LoginRoles } from 'src/app/model/common.model';
import { LocalizedString } from 'src/app/model/localized-string.model';

@Component({
    selector: 'app-add-product',
    templateUrl: './add-product.component.html',
    styleUrl: './add-product.component.css',
    standalone: false
})
export class AddProductComponent implements OnInit {
  showLoader: boolean = false;
  showDiscount: boolean = true;
  showSelling: boolean = false;
  protected readonly isFoodClassificationEnabled = environment.foodClassificationEnabled;
  protected readonly isInventoryAlertsEnabled = environment.inventoryAlertsEnabled;
  model: any = {
    name: { en: '', te: '' },
    description: { en: '', te: '' },
    status: true,
    discorselling: 'disc',
    selectedTag: [],
    selectedBrand: '',
    minQty: [],
    minExpiryDate: [],
    type: "",
    unit: "",
    foodClassType: "",
    foodClassTaste: "",
    rentalPeriodValue: null,
    rentalPeriodUnit: "month",
    rentalSecurityDeposit: 0,
    discount: "",
    sellingPrice: "",
    inHouseProduct: false,
    isEcommerceVisible: true,
    gst:{}
  };
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  mainCategoryList: any = [];
  categoryList: any = [];
  subCategoryList: any = [];
  tagsList: any = [];
  brandsList: any = [];
  zonesList: any = [];
  serviceCategoryListForRelevant: any[] = [];
  packageCategoryListForRelevant: any[] = [];
  selectedRelevantServiceCategory = [];
  selectedRelevantPackCategory = [];
  relevantServiceOptions: any[] = [];
  relevantPackOptions: any[] = [];
  pendingRelevantServiceCategoryId = '';
  pendingRelevantPackCategoryId = '';
  private loaderService = inject(LoadingBarService);
  private loadingBarRef = this.loaderService.useRef();

  closeResult = '';
  dropdownSettings: any = {};
  dropdownSettingsTags: any = {};
  dropdownSettingsZones = {
    singleSelection: true,
    idField: '_id',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true
  };
  dropdownSettingsRetailers = {
    singleSelection: true,
    idField: '_id',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  };
  dropdownBrandSettings = {
    singleSelection: true,
    idField: 'name',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true
  }
  unitList: any = unitList;
  tagData: any = {};
  brandData: any = {};
  imageUrls: any = [
    {
      image: ""
    }
  ];
  private routeSub: Subscription;
  isEditPage: boolean = false;
  isUnitValueValidatorRequired: boolean = true;
  isMainCategorySelectionLocked: boolean = false;
  isCategorySelectionLocked: boolean = false;
  selectedZoneListData: any[] = [];
  previousSelectedZoneData: any[] = [];
  filteredZoneList: any[] = [];
  retailersByZone: Record<string, any[]> = {};
  isZoneDataValid: boolean;
  isZoneAdmin: boolean = false;
  zoneAdminZoneId: string = '';


  constructor(private route: ActivatedRoute, private authServiceUser: AuthServiceUser, private apiService: ApiServiceListService, private http: HttpClient, private modalService: NgbModal,
    private router: Router, private dimensionService: DimensionsService, private toastr: ToastrService, protected cmnService: CommonService) { }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(params => {
      // console.log(params) //log the entire params object
      // console.log(params['id']) //log the value of id
      if (params != undefined && params['id'] != undefined) {
        this.isEditPage = true
        this.getProductById(params['id']);
      } else {
        this.isEditPage = false;
      }
    });

    const loginUserDetails = this.authServiceUser.getUserInfo();
    this.isZoneAdmin = loginUserDetails.role.includes(LoginRoles.ZONEADMIN);
    this.zoneAdminZoneId = loginUserDetails?.zone?._id || '';

    if (!this.isEditPage) {
      this.updateCategorySelectionLocks(this.model.type);
    }

    this.getTagsList();
    this.getBrandList();
    this.getServiceCategoriesForRelevant();
    this.getPackageCategoriesForRelevant();
    this.getZonesList();
    this.breadcrumb = {
      'mainlabel': 'Product Management',
      // 'links': [
      //   {
      //     'name': 'Home',
      //     'isLink': false,
      //     'link': '/dashboard/sales'
      //   },
      //   {
      //     'name': 'ChangeLog',
      //     'isLink': false,
      //     'link': '#'
      //   },
      // ]
    };
    this.dropdownSettings = {
      singleSelection: true,
      idField: '_id',
      textField: 'displayName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

    this.dropdownSettingsTags = {
      singleSelection: false,
      idField: 'name',
      textField: 'name',
      enableCheckAll: false,
      itemsShowLimit: 10,
      allowSearchFilter: true
    };
  }

  private toLocalizedString(value: any): LocalizedString {
    return this.toLocalizedStringWithFallback(value);
  }

  private getFirstNonEmptyString(values: any[] = []): string {
    const validValue = values.find(item => typeof item === 'string' && item.trim() !== '');
    return typeof validValue === 'string' ? validValue : '';
  }

  private toLocalizedStringWithFallback(value: any, teFallbacks: any[] = [], enFallbacks: any[] = []): LocalizedString {
    let en = '';
    let te = '';

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      en = this.getFirstNonEmptyString([
        value.en,
        value.english,
        value.enUS,
        value.en_us,
        value['en-US'],
        value['en-IN'],
      ]);

      te = this.getFirstNonEmptyString([
        value.te,
        value.telugu,
        value.teIN,
        value.te_in,
        value['te-IN'],
      ]);
    } else if (typeof value === 'string') {
      en = value;
    }

    if (!en) {
      en = this.getFirstNonEmptyString(enFallbacks);
    }
    if (!te) {
      te = this.getFirstNonEmptyString(teFallbacks);
    }

    return { en, te };
  }

  getLocalizedText(value: any): string {
    const localized = this.toLocalizedString(value);
    return localized.en || localized.te || '';
  }

  private withDisplayName(item: any): any {
    if (!item || typeof item !== 'object') {
      return item;
    }
    return {
      ...item,
      displayName: this.getLocalizedText(item.name),
    };
  }

  private mapCategoryList(list: any[] = []): any[] {
    return list.map(item => this.withDisplayName(item));
  }

  private normalizeCategorySelection(selection: any): any[] {
    if (!selection) {
      return [];
    }
    const items = Array.isArray(selection) ? selection : [selection];
    return items.map(item => this.withDisplayName(item));
  }

  inHouseProductList: any = []

  onInHouseProductChange() {
    if (this.model.inHouseProduct) {
      this.apiService.getRKMRTProducts().subscribe({
        next: (response: any) => {
          this.inHouseProductList = response.data;
          this.generateRkmrtProductBarcode();
        },
        error: (error) => {
          this.toastr.error(error.message, '', {
            timeOut: 3000,
          });
          this.showLoader = false;
        }
      });
    } else {
      this.unitList = unitList;
      // this.model.mrpPrice = 0;
      // this.model.sellingPrice = 0;
      // this.model.discount = 0;
      // this.showDiscount = true;
      // this.showSelling = false;
    }
  }

  onInHouseProductNameChange(event) {
    // console.log(event);
    // const target = event.target as HTMLSelectElement;

    // console.log('Selected Value:', target.value);

    console.log(this.model.rakemartId);
    const selectedObj = this.inHouseProductList.find(item => item._id === this.model.rakemartId);
    if (selectedObj) {
      this.model.name = this.toLocalizedString(selectedObj.name);
      this.model.barcode = selectedObj.barcode;
      this.model.unit = selectedObj.unit;
      this.unitList = this.getUnitValueList(selectedObj.unit);
    }
    // Append basic barcode to the current product barcode
  }

  getUnitValueList(selectedValue){
    switch(selectedValue){
      case "Kg":
      case "gm":
        return unitList.filter(item => item.type === 'gms');
      case "ml":
      case "liters":
        return unitList.filter(item => item.type === 'liters');
      case "piece":
        return unitList.filter(item => item.type === 'piece');
      case "pack":
        return unitList.filter(item => item.type === 'pack');
        default:
        return unitList
    }
  }

  onUnitChange() {
    if (this.model.inHouseProduct) {
      this.generateRkmrtProductBarcode();
    }
  }

  onUnitValueChange() {
    if (this.model.inHouseProduct) {
      this.generateRkmrtProductBarcode();
    }
  }

  generateRkmrtProductBarcode() {
    if (!this.model.barcode || !this.model.unit || !this.model.unitValue) return;
    let payload = {
      barcode: this.model.barcode.split('-')[0],
      unit: this.model.unit,
      unitValue: this.model.unitValue
    }
    this.apiService.generateRkmrtProductBarcode(payload)
      .subscribe({
        next: (response: any) => {
          this.model.barcode = response.barcode;
        },
        error: (error) => {
          this.toastr.error(error.message, '', {
            timeOut: 3000,
          });
          this.showLoader = false;
        }
      });
  }

  private resetRentalFields() {
    this.model.rentalPeriodValue = null;
    this.model.rentalPeriodUnit = "month";
    this.model.rentalSecurityDeposit = 0;
  }

  private getCategoryModelForType(type: string): string | undefined {
    const productType = (type || '').toString().trim().toLowerCase();
    if (productType === 'grocery') {
      return 'product';
    }
    if (productType === 'kitchen') {
      return 'kitchen';
    }
    if (productType === 'rental') {
      return 'product';
    }
    return undefined;
  }

  private updateCategorySelectionLocks(type: string): void {
    const productType = (type || '').toString().trim().toLowerCase();
    this.isMainCategorySelectionLocked = productType === 'kitchen';
    this.isCategorySelectionLocked = false;
    this.isUnitValueValidatorRequired = !(productType === 'kitchen' || productType === 'rental');
  }

  private normalizeCategoryId(value: any): string {
    const rawValue = value?._id ?? value;
    return rawValue ? String(rawValue) : '';
  }

  private findCategoryById(list: any[] = [], categoryId: any): any {
    const normalizedCategoryId = this.normalizeCategoryId(categoryId);
    if (!normalizedCategoryId) {
      return null;
    }
    return list.find((item) => this.normalizeCategoryId(item?._id ?? item) === normalizedCategoryId) || null;
  }

  private findCategoryByName(list: any[] = [], expectedName: string): any {
    const normalizedExpectedName = (expectedName || '').trim().toLowerCase();
    if (!normalizedExpectedName) {
      return null;
    }
    return list.find((item) => {
      const displayName = (item?.displayName || this.getLocalizedText(item?.name) || '').toString().trim().toLowerCase();
      return displayName === normalizedExpectedName;
    }) || null;
  }

  private applyProductMainCategoryDefaults(): void {
    this.getMainCategory('product', () => {
      const defaultMainCategory = this.findCategoryByName(this.mainCategoryList, 'Pooja Store') || this.mainCategoryList[0];
      this.model.mainCategory = defaultMainCategory ? [defaultMainCategory] : [];
      this.model.category = [];
      this.model.subCategory = [];
      if (defaultMainCategory) {
        this.getCategory();
      }
    });
  }

  private applyRentalCategoryDefaults(): void {
    this.getMainCategory('product', () => {
      this.model.mainCategory = [];
      this.model.category = [];
      this.model.subCategory = [];

      this.apiService.getCategoriesByModel('product').subscribe({
        next: (response: any) => {
          const allProductModelCategories = this.mapCategoryList(response?.data || []);
          const activeProductModelCategories = allProductModelCategories.filter(
            (item) => (item?.status || '').toString().trim().toLowerCase() === 'active',
          );
          const categoryPool = activeProductModelCategories.length
            ? activeProductModelCategories
            : allProductModelCategories;

          const rentalSubCategory = this.findCategoryByName(
            categoryPool.filter((item) => item?.type === 'sub'),
            'Rental',
          );
          if (!rentalSubCategory) {
            return;
          }

          const rentalMainCategory = this.findCategoryById(
            this.mainCategoryList,
            rentalSubCategory.mainCategory,
          );
          const rentalCategory = this.findCategoryById(
            categoryPool.filter((item) => item?.type === 'category'),
            rentalSubCategory.category,
          );
          if (!rentalMainCategory || !rentalCategory) {
            return;
          }

          this.model.mainCategory = [rentalMainCategory];
          this.getCategory({
            selectedCategoryId: rentalCategory._id,
            fetchSubCategoryOnSelect: true,
            selectedSubCategoryId: rentalSubCategory._id,
          });
        },
        error: (err) => {
          console.log(err);
        },
      });
    });
  }

  onTypeChange() {
    const isKitchen = this.model.type === 'kitchen';
    const isRental = this.model.type === 'rental';
    this.updateCategorySelectionLocks(this.model.type);

    this.model.mainCategory = [];
    this.model.category = [];
    this.model.subCategory = [];
    this.mainCategoryList = [];
    this.categoryList = [];
    this.subCategoryList = [];

    if (isKitchen) {
      this.loadKitchenMainCategory();
    } else if (isRental) {
      this.applyRentalCategoryDefaults();
    } else {
      this.applyProductMainCategoryDefaults();
    }

    if (!isRental) {
      this.resetRentalFields();
    }

    // Product type determines retailer type for zone mappings.
    this.combinedZoneList.forEach((item) => {
      item.retailer = [];
      item.retailerId = '';
      item.retailerName = '';
      this.fetchRetailersByZone(item.zoneId, true);
    });

  }

  onMrpChange() {
    // console.log(this.model.mrpPrice, this.model.discorselling, this.model.discount, this.model.sellingPrice);

    if (this.model.discorselling === 'disc' && this.model.discount !== "") {
      this.model.sellingPrice = Math.ceil(this.model.mrpPrice * (100 - this.model.discount) / 100);
    }

    if (this.model.discorselling === 'selling' && this.model.sellingPrice !== "") {
      this.model.discount = 100 - (this.model.sellingPrice / this.model.mrpPrice) * 100;
    }

    if (this.model.sellingPrice < 0 || this.model.discount < 0) {
      this.toastr.error("Check discount and Selling price once", '', {
        timeOut: 3000,
      });
    }
  }

  onZoneMrpChange(item) {
    if (item.discorselling === 'disc' && item.discount !== "") {
      item.sellingPrice = Math.ceil(item.mrpPrice * (100 - item.discount) / 100);
    }

    if (item.discorselling === 'selling' && item.sellingPrice !== "") {
      item.discount = 100 - (item.sellingPrice / item.mrpPrice) * 100;
    }

    if (item.sellingPrice < 0 || item.discount < 0) {
      this.toastr.error("Check discount and Selling price once", '', {
        timeOut: 3000,
      });
    }
  }

  getProductById(id: string) {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getProductById(parameter, id)
      .subscribe({
        next: (response: any) => {
          const product = response.data.product;
          product.name = this.toLocalizedStringWithFallback(product.name, [
            product.nameTe,
            product.name_te,
            product.teName,
            product.teluguName,
          ]);
          product.description = this.toLocalizedStringWithFallback(product.description, [
            product.descriptionTe,
            product.description_te,
            product.teDescription,
            product.teluguDescription,
            product.descTe,
          ]);
          product.mainCategory = this.normalizeCategorySelection(product.mainCategory);
          product.category = this.normalizeCategorySelection(product.category);
          product.subCategory = this.normalizeCategorySelection(product.subCategory);
          product.status = this.cmnService.getStatusRetrunValue(product.status);
          product.isEcommerceVisible = product.isEcommerceVisible !== false;
          this.model = { ...product };

          if (this.model.barcode.startsWith('RKMRT')) {
            this.model.inHouseProduct = true;
          }

          this.imageUrls = [];
          for (let i = 0; i < this.model.imageUrl.length; i++) {
            const element = this.model.imageUrl[i];
            this.imageUrls.push({ image: element });
          }
          this.getMainCategory(this.getCategoryModelForType(this.model.type));
          this.getCategory();
          this.getSubCategory();

          this.model.selectedTag = [];
          if (Array.isArray(product.tags) && product.tags.length) {
            this.model.selectedTag = product.tags.map((tag: string) => ({ _id: tag, name: tag }));
          }
          this.model.selectedBrand = [];
          if (product.brand) {
            const element = product.brand;
            this.model.selectedBrand.push({ _id: element, name: element });
          }

          if (this.isInventoryAlertsEnabled && product.alerts) {
            product.alerts.forEach(element => {
              if (element.type === 'min-quantity') {
                this.model.minQty = element.value;
              }
              if (element.type === 'min-expiry-date') {
                this.model.minExpiryDate = element.value;
              }
            });
          }
          this.model.discorselling = 'disc';

          if(!this.model.gst){
            this.model.gst = {}
          }

          if(!this.model.minQty){
            this.model.minQty = [];
          }

          if(!this.model.minExpiryDate){
            this.model.minExpiryDate = [];
          }

          this.previousSelectedZoneData = this.formatExitingZoneProductData(response.data?.productZones ?? []);

          this.getUpdatedZoneList();
          this.previousSelectedZoneData.forEach((item) => this.fetchRetailersByZone(item.zoneId));
          this.ensureSelectedRelevantOptionsFromRows();
          this.hydrateRelevantMappingsForEdit();
          // this.onTypeChange();
          this.updateCategorySelectionLocks(this.model.type);
        },
        error: (err) => {
          console.log(err);
        },
      });

  }
  addNewImage() {
    this.imageUrls.push({

      image: ""
    });
  }

  removeImage(index: number) {
    this.imageUrls.splice(index, 1);
  }


  getMainCategory(categoryModel?: string, onLoaded?: () => void) {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getMainCategoryList(parameter, categoryModel).subscribe({
      next: (response: any) => {
        this.mainCategoryList = this.mapCategoryList(response.data);
        onLoaded?.();
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  private loadKitchenMainCategory() {
    let parameter: any = {
      methodType: "GET",
    };
    this.apiService.getKitchenMainCategory(parameter).subscribe({
      next: (response: any) => {
        const kitchenMainCategory = response?.data ? this.withDisplayName(response.data) : null;
        if (!kitchenMainCategory) {
          this.model.mainCategory = [];
          this.mainCategoryList = [];
          return;
        }
        this.mainCategoryList = [kitchenMainCategory];
        this.model.mainCategory = [kitchenMainCategory];
        this.getCategory();
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  getCategory(options?: {
    defaultCategoryName?: string,
    fallbackToFirst?: boolean,
    fetchSubCategoryOnSelect?: boolean,
    selectedCategoryId?: string,
    selectedSubCategoryId?: string,
  }) {
    if (!this.model.mainCategory?.[0]) return;

    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    body.mainCategory = this.model.mainCategory[0]?._id ?? this.model.mainCategory[0];
    this.apiService.getCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.categoryList = this.mapCategoryList(response.data);
        const selectedCategoryId = options?.selectedCategoryId;
        if (selectedCategoryId) {
          const selectedCategory = this.findCategoryById(this.categoryList, selectedCategoryId);
          this.model.category = selectedCategory ? [selectedCategory] : [];
          if (selectedCategory && options?.fetchSubCategoryOnSelect) {
            this.getSubCategory({ selectedSubCategoryId: options?.selectedSubCategoryId });
          }
          return;
        }
        const defaultCategoryName = options?.defaultCategoryName;
        if (defaultCategoryName) {
          const defaultCategory = this.findCategoryByName(this.categoryList, defaultCategoryName)
            || (options?.fallbackToFirst ? this.categoryList[0] : null);
          this.model.category = defaultCategory ? [defaultCategory] : [];
          if (defaultCategory && options?.fetchSubCategoryOnSelect) {
            this.getSubCategory({ selectedSubCategoryId: options?.selectedSubCategoryId });
          }
          return;
        }
        if (this.model.type === 'kitchen' && this.categoryList.length === 1) {
          this.model.category = [this.categoryList[0]];
          this.getSubCategory();
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  getSubCategory(options?: { selectedSubCategoryId?: string }) {
    if (!this.model.category?.[0]) return;

    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    body.category = this.model.category[0]?._id ?? this.model.category[0];
    this.apiService.getSubCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.subCategoryList = this.mapCategoryList(response.data);
        const selectedSubCategoryId = options?.selectedSubCategoryId;
        if (selectedSubCategoryId) {
          const selectedSubCategory = this.findCategoryById(this.subCategoryList, selectedSubCategoryId);
          this.model.subCategory = selectedSubCategory ? [selectedSubCategory] : [];
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getTagsList() {
    this.apiService.getTagsList().subscribe(
      {
        next: (response: any) => {
          this.tagsList = response.data;
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }

  getBrandList() {
    this.apiService.getBrandsList().subscribe(
      {
        next: (response: any) => {
          this.brandsList = response.data;
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }

  updateDrpdown(type: string) {
    if (type == 'main') {
      this.getCategory();
      this.model.category = [];
      this.model.subCategory = [];
    } else if (type == 'cate') {
      this.getSubCategory();
      this.model.subCategory = [];
    }
  }

  discountOrSelling() {
    if (this.model.discorselling == 'disc') {
      this.showDiscount = true;
      this.showSelling = false;
    } else {
      this.showDiscount = false;
      this.showSelling = true;
    }
  }



  saveTag() {
    this.tagData.name = this.tagData.name.trim();
    this.http.post(environment.baseAPIHost + environment.postTagsListAPIHost, this.tagData)
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.getTagsList();
            this.modalService.dismissAll();
            this.closeResult = `Dismissed ${this.getDismissReason('Submitted successfully')}`;

          } else {
            this.toastr.error(response.message, '', {
              timeOut: 3000,
            });
          }
          this.showLoader = false;

        },
        error: (error) => {
          this.toastr.error(error.message, '', {
            timeOut: 3000,
          });
          this.showLoader = false;

        }
      })
  }

  saveBrand() {
    // this.brandData.status = "Active";
    this.brandData.name = this.brandData.name.trim();
    this.http.post(environment.baseAPIHost + environment.postBrandListAPIHost, this.brandData)
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.getBrandList();
            this.modalService.dismissAll();
            this.closeResult = `Dismissed ${this.getDismissReason('Submitted successfully')}`;


          } else {
            this.toastr.error(response.message, '', {
              timeOut: 3000,
            });
          }
          this.showLoader = false;

        },
        error: (error) => {
          this.toastr.error(error.message, '', {
            timeOut: 3000,
          });
          this.showLoader = false;

        }
      })
  }

  openModal(OpenShowModelContent) {
    let self = this;
    this.brandData = {};
    this.tagData = {};
    self.modalService.open(OpenShowModelContent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'lg', centered: true }).result.then((result) => {
      if (result == 'Save Click') {
        self.saveTag();
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private resolveOptionalId(value: any): string {
    if (!value) return '';
    if (typeof value === 'object') {
      return value._id || value.id || '';
    }
    return String(value);
  }

  private appendOptionIfMissing(list: any[], option: { _id: string; name: string }) {
    if (!option?._id) return list;
    if (list.some((item) => item?._id === option._id)) return list;
    return [option, ...list];
  }

  private ensureSelectedRelevantOptionsFromRows() {
    const rows = this.combinedZoneList || [];
    let serviceOptions = [...this.relevantServiceOptions];
    let packOptions = [...this.relevantPackOptions];

    rows.forEach((row) => {
      const serviceId = this.resolveOptionalId(row?.relevantService);
      if (serviceId) {
        serviceOptions = this.appendOptionIfMissing(serviceOptions, {
          _id: serviceId,
          name: row?.relevantServiceName || serviceId,
        });
      }

      const packId = this.resolveOptionalId(row?.relevantPack);
      if (packId) {
        packOptions = this.appendOptionIfMissing(packOptions, {
          _id: packId,
          name: row?.relevantPackName || packId,
        });
      }
    });

    this.relevantServiceOptions = serviceOptions;
    this.relevantPackOptions = packOptions;
  }

  private hydrateRelevantMappingsForEdit() {
    const rows = this.combinedZoneList || [];
    const serviceIds = Array.from(
      new Set(
        rows
          .map((row: any) => this.resolveOptionalId(row?.relevantService))
          .filter((id: string) => !!id)
      )
    );
    const packIds = Array.from(
      new Set(
        rows
          .map((row: any) => this.resolveOptionalId(row?.relevantPack))
          .filter((id: string) => !!id)
      )
    );

    serviceIds.forEach((serviceId) => {
      this.apiService.getServiceById(serviceId).subscribe({
        next: (response: any) => {
          const service = response?.data || {};
          const serviceName = this.getLocalizedText(service?.name) || serviceId;
          this.relevantServiceOptions = this.appendOptionIfMissing(this.relevantServiceOptions, {
            _id: serviceId,
            name: serviceName,
          });
          rows.forEach((row: any) => {
            if (this.resolveOptionalId(row?.relevantService) === serviceId) {
              row.relevantServiceName = serviceName;
            }
          });
          const categoryId = this.resolveOptionalId(service?.category);
          if (categoryId && !this.resolveCategoryId(this.selectedRelevantServiceCategory)) {
            const matchedCategory = this.serviceCategoryListForRelevant.find(
              (item) => item?._id === categoryId
            );
            if (matchedCategory) {
              this.selectedRelevantServiceCategory = [matchedCategory];
              this.loadRelevantServiceOptions();
            } else {
              this.pendingRelevantServiceCategoryId = categoryId;
            }
          }
        },
        error: () => {},
      });
    });

    packIds.forEach((packId) => {
      this.apiService.getMonthlyPackByIdAPI({ methodType: "GET" }, packId).subscribe({
        next: (response: any) => {
          const pack = response?.data || {};
          const packName = this.getLocalizedText(pack?.name) || packId;
          this.relevantPackOptions = this.appendOptionIfMissing(this.relevantPackOptions, {
            _id: packId,
            name: packName,
          });
          rows.forEach((row: any) => {
            if (this.resolveOptionalId(row?.relevantPack) === packId) {
              row.relevantPackName = packName;
            }
          });
          const categoryId = this.resolveOptionalId(pack?.category);
          if (categoryId && !this.resolveCategoryId(this.selectedRelevantPackCategory)) {
            const matchedCategory = this.packageCategoryListForRelevant.find(
              (item) => item?._id === categoryId
            );
            if (matchedCategory) {
              this.selectedRelevantPackCategory = [matchedCategory];
              this.loadRelevantPackOptions();
            } else {
              this.pendingRelevantPackCategoryId = categoryId;
            }
          }
        },
        error: () => {},
      });
    });
  }

  getServiceCategoriesForRelevant() {
    this.apiService.getServiceCategories().subscribe({
      next: (response: any) => {
        this.serviceCategoryListForRelevant = (response?.data || []).map((item) => this.withDisplayName(item));
        if (this.pendingRelevantServiceCategoryId) {
          const matchedCategory = this.serviceCategoryListForRelevant.find(
            (item) => item?._id === this.pendingRelevantServiceCategoryId
          );
          if (matchedCategory) {
            this.selectedRelevantServiceCategory = [matchedCategory];
            this.loadRelevantServiceOptions();
          }
          this.pendingRelevantServiceCategoryId = '';
        }
      },
      error: () => {
        this.serviceCategoryListForRelevant = [];
      }
    });
  }

  getPackageCategoriesForRelevant() {
    this.apiService.getPackageCategories().subscribe({
      next: (response: any) => {
        this.packageCategoryListForRelevant = (response?.data || []).map((item) => this.withDisplayName(item));
        if (this.pendingRelevantPackCategoryId) {
          const matchedCategory = this.packageCategoryListForRelevant.find(
            (item) => item?._id === this.pendingRelevantPackCategoryId
          );
          if (matchedCategory) {
            this.selectedRelevantPackCategory = [matchedCategory];
            this.loadRelevantPackOptions();
          }
          this.pendingRelevantPackCategoryId = '';
        }
      },
      error: () => {
        this.packageCategoryListForRelevant = [];
      }
    });
  }

  private resolveCategoryId(categorySelection: any): string {
    const first = Array.isArray(categorySelection) ? categorySelection[0] : categorySelection;
    return first?._id || first?.categoryId || first || '';
  }

  onRelevantServiceCategoryChange() {
    this.loadRelevantServiceOptions();
  }

  onRelevantPackCategoryChange() {
    this.loadRelevantPackOptions();
  }

  private getRelevantScopeFromMappings(): { zoneIds: string[]; retailerIds: string[] } {
    const zoneSet = new Set<string>();
    const retailerSet = new Set<string>();
    (this.combinedZoneList || []).forEach((row: any) => {
      const zoneId = this.resolveOptionalId(row?.zoneId || row?.zone?._id || row?.zone);
      const selectedRetailer = Array.isArray(row?.retailer) ? row.retailer[0] : row?.retailer;
      const retailerId = this.resolveOptionalId(
        selectedRetailer?._id || row?.retailerId || selectedRetailer
      );
      if (zoneId && retailerId) {
        zoneSet.add(zoneId);
        retailerSet.add(retailerId);
      }
    });
    return {
      zoneIds: Array.from(zoneSet),
      retailerIds: Array.from(retailerSet),
    };
  }

  private refreshRelevantOptionsForKitchenScope() {
    if (this.model.type !== 'kitchen') return;
    if (this.resolveCategoryId(this.selectedRelevantServiceCategory)) {
      this.loadRelevantServiceOptions();
    }
    if (this.resolveCategoryId(this.selectedRelevantPackCategory)) {
      this.loadRelevantPackOptions();
    }
  }

  loadRelevantServiceOptions() {
    const categoryId = this.resolveCategoryId(this.selectedRelevantServiceCategory);
    if (!categoryId) {
      this.relevantServiceOptions = [];
      this.ensureSelectedRelevantOptionsFromRows();
      return;
    }

    const { zoneIds, retailerIds } = this.getRelevantScopeFromMappings();
    if (!zoneIds.length || !retailerIds.length) {
      this.relevantServiceOptions = [];
      this.ensureSelectedRelevantOptionsFromRows();
      return;
    }

    const parameter: any = {
      body: {
        pageSize: 500,
        currentPage: 1,
        totalCount: 0,
        filteredValue: [{ status: ['Active'] }, { category: [categoryId] }, { zones: zoneIds }],
        searchValue: '',
        sortColumn: 'updatedAt',
        sortOrder: 'desc',
      }
    };

    this.apiService.getServiceTableData(parameter).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data?.tableData) ? response.data.tableData : [];
        this.relevantServiceOptions = rows.map((row) => ({
          _id: row._id,
          name: row.name || row._id,
        }));
        this.ensureSelectedRelevantOptionsFromRows();
      },
      error: () => {
        this.relevantServiceOptions = [];
        this.ensureSelectedRelevantOptionsFromRows();
      }
    });
  }

  loadRelevantPackOptions() {
    const categoryId = this.resolveCategoryId(this.selectedRelevantPackCategory);
    if (!categoryId) {
      this.relevantPackOptions = [];
      this.ensureSelectedRelevantOptionsFromRows();
      return;
    }

    const { zoneIds, retailerIds } = this.getRelevantScopeFromMappings();
    if (!zoneIds.length || !retailerIds.length) {
      this.relevantPackOptions = [];
      this.ensureSelectedRelevantOptionsFromRows();
      return;
    }

    const parameter: any = {
      body: {
        pageSize: 500,
        currentPage: 1,
        totalCount: 0,
        filteredValue: [{ status: ['Active'] }, { category: [categoryId] }, { zone: zoneIds }],
        searchValue: '',
        sortColumn: 'updatedAt',
        sortOrder: 'desc',
      }
    };

    this.apiService.getMonthlyPackAPI(parameter).subscribe({
      next: (response: any) => {
        const rows = Array.isArray(response?.data?.tableData) ? response.data.tableData : [];
        this.relevantPackOptions = rows.map((row) => ({
          _id: row._id,
          name: row.name || row._id,
        }));
        this.ensureSelectedRelevantOptionsFromRows();
      },
      error: () => {
        this.relevantPackOptions = [];
        this.ensureSelectedRelevantOptionsFromRows();
      }
    });
  }

  getZonesList() {
    this.apiService.getZonesList().subscribe(
      {
        next: (response: any) => {
          this.zonesList = response.data;
          this.getUpdatedZoneList();
          if (this.isZoneAdmin && !this.isEditPage && this.combinedZoneList.length === 0) {
            const zone = this.zonesList.find((item) => item._id === this.zoneAdminZoneId);
            if (zone) {
              this.addZoneMappingRow(zone);
              this.fetchRetailersByZone(zone._id);
            }
          }
        },
        error: (err) => {
          console.log(err);
        }
      }
    );
  }


  get combinedZoneList() {
    return [...this.selectedZoneListData, ...this.previousSelectedZoneData];
  }

  onZoneselect(event: any) {
    const selectedZone = event?._id ? event : null;
    if (!selectedZone) {
      return;
    }
    this.addZoneMappingRow(selectedZone);
    this.fetchRetailersByZone(selectedZone._id);
    this.model.selectedZone = [];
    this.refreshRelevantOptionsForKitchenScope();
  }

  addRetailerMapping(item: any): void {
    this.selectedZoneListData.push({
      rowId: `${item.zoneId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      zoneId: item.zoneId,
      zoneName: item.zoneName,
      mrpPrice: item.mrpPrice,
      discount: item.discount,
      sellingPrice: item.sellingPrice,
      status: item.status,
      tags: Array.isArray(item.tags) ? [...item.tags] : [],
      retailer: [],
      retailerId: '',
      retailerName: '',
      relevantService: this.resolveOptionalId(item.relevantService) || '',
      relevantServiceName: item.relevantServiceName || '',
      relevantPack: this.resolveOptionalId(item.relevantPack) || '',
      relevantPackName: item.relevantPackName || '',
      isFeatureProduct: item.isFeatureProduct,
      discorselling: item.discorselling,
      showDiscount: item.showDiscount,
      showSelling: item.showSelling,
    });
    this.fetchRetailersByZone(item.zoneId);
    this.refreshRelevantOptionsForKitchenScope();
  }

  removeZoneRow(item: any): void {
    if (item._id) {
      this.toastr.error('Removing existing zone mappings is not supported from this screen.', '', {
        timeOut: 3000,
      });
      return;
    } else if (item.rowId) {
      this.selectedZoneListData = this.selectedZoneListData.filter((row) => row.rowId !== item.rowId);
      this.refreshRelevantOptionsForKitchenScope();
    }
  }

  navigateTOList() {
    this.router.navigateByUrl('/product/all');
  }

  updateDiscountOrSelling(item: any): void {
    item.showDiscount = item.discorselling === 'disc';
    item.showSelling = item.discorselling === 'selling';
  }

  // updateStatus(item: any): void {
  //   item.status = item.status ? 'active' : 'inactive';
  // }

  formattedZoneData(value) {
    this.isZoneDataValid = true;
    return value.map(element => {
      let obj: any = {};
      obj.zone = element.zoneId;
      if (element._id) {
        obj._id = element._id;
      }
      const selectedRetailer = Array.isArray(element.retailer) ? element.retailer[0] : element.retailer;
      obj.retailer = selectedRetailer?._id || element.retailerId || (typeof selectedRetailer === 'string' ? selectedRetailer : null);
      obj.mrpPrice = element.mrpPrice;
      if (element.discorselling === 'disc') {
        obj.discount = element.discount;
      } else {
        obj.sellingPrice = element.sellingPrice;
      }

      if (typeof element.status === 'boolean') {
        obj.status = this.cmnService.getStatusValue(element.status);
      } else {
        obj.status = element.status;
      }

      obj.tags = [];
      const zoneTags = Array.isArray(element.tags) ? element.tags : [];
      for (let i = 0; i < zoneTags.length; i++) {
        const selectedObj = zoneTags[i];
        obj.tags.push(typeof selectedObj === 'string' ? selectedObj : selectedObj.name);
      }

      obj.isFeatureProduct = element.isFeatureProduct;
      if (this.model.type === 'kitchen') {
        obj.relevantService = this.resolveOptionalId(element.relevantService) || null;
        obj.relevantPack = this.resolveOptionalId(element.relevantPack) || null;
      }

      if (!obj.retailer) {
        this.isZoneDataValid = false;
        this.toastr.error('Retailer is required for zone ' + element.zoneName, '', {
          timeOut: 3000,
        });
      }

      if (!obj.tags.length) {
        this.isZoneDataValid = false;
        this.toastr.error('At least one tag is required for zone ' + element.zoneName, '', {
          timeOut: 3000,
        });
      }

      if ((element.discorselling === 'selling' && element.mrpPrice < element.sellingPrice) || (element.discorselling === 'disc' && element.discount > 100)) {
        this.isZoneDataValid = false;
        this.toastr.error('Check discount and Selling price once for zone ' + element.zoneName, '', {
          timeOut: 3000,
        });
      }

      // formattedZoneList.push(obj);
      return obj;
    });

  }

  trackByFn(index: number, item: any): any {
    return item._id || item.rowId || index;
  }

  formatExitingZoneProductData(zoneData) {
    return zoneData.map(element => {
      let tagsList = [];
      if (element.tags) {
        for (let i = 0; i < element.tags.length; i++) {
          const itemTag = element.tags[i];
          tagsList.push({ _id: itemTag, name: itemTag });
        }
      }
      const useDiscount = element.discount !== undefined && element.discount !== null;
      const retailerName = element.retailer?.name || '';
      return {
        _id: element._id,
        rowId: element._id,
        zoneId: element.zone?._id,
        zoneName: element.zone?.name,
        retailerId: element.retailer?._id || '',
        retailerName: retailerName,
        retailer: element.retailer?._id ? [{ _id: element.retailer._id, name: retailerName }] : [],
        mrpPrice: element.mrpPrice,
        discount: element.discount,
        sellingPrice: element.sellingPrice,
        status: this.cmnService.getStatusRetrunValue(element.status),
        tags: tagsList,
        relevantService: this.resolveOptionalId(element.relevantService) || '',
        relevantServiceName: this.getLocalizedText(element.relevantService?.name) || element.relevantService?.name || '',
        relevantPack: this.resolveOptionalId(element.relevantPack) || '',
        relevantPackName: this.getLocalizedText(element.relevantPack?.name) || element.relevantPack?.name || '',
        isFeatureProduct: element.isFeatureProduct,
        discorselling: useDiscount ? 'disc' : 'selling',
        showDiscount: useDiscount,
        showSelling: !useDiscount,
      }
    })

  }

  getUpdatedZoneList() {
    this.filteredZoneList = [...this.zonesList];
  }

  private getRetailerType(): string {
    const productType = (this.model.type || '').toString().trim().toLowerCase();
    if (productType === 'rental') {
      return 'grocery';
    }
    if (productType === 'kitchen' || productType === 'grocery') {
      return productType;
    }
    return '';
  }

  private getRetailerCacheKey(zoneId: string): string {
    const type = this.getRetailerType();
    return `${zoneId}::${type || 'all'}`;
  }

  private addZoneMappingRow(selectedZone: any): void {
    const defaultTags = Array.isArray(this.model.selectedTag) ? [...this.model.selectedTag] : [];
    this.selectedZoneListData.push({
      rowId: `${selectedZone._id}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      zoneId: selectedZone._id,
      zoneName: selectedZone.name,
      mrpPrice: this.model.mrpPrice,
      discount: this.model.discount,
      sellingPrice: this.model.sellingPrice,
      status: 'Active',
      tags: defaultTags,
      retailer: [],
      retailerId: '',
      retailerName: '',
      relevantService: '',
      relevantServiceName: '',
      relevantPack: '',
      relevantPackName: '',
      isFeatureProduct: false,
      discorselling: this.showDiscount ? 'disc' : 'selling',
      showDiscount: this.showDiscount,
      showSelling: this.showSelling,
    });
  }

  fetchRetailersByZone(zoneId: string, forceRefresh: boolean = false): void {
    if (!zoneId) return;
    const cacheKey = this.getRetailerCacheKey(zoneId);
    if (this.retailersByZone[cacheKey] && !forceRefresh) return;

    const retailerType = this.getRetailerType();
    const payload: any = { zone: zoneId };
    if (retailerType) {
      payload.type = retailerType;
    }

    this.apiService.getRetailersListByZoneAndType(payload).subscribe({
      next: (response: any) => {
        const retailers = Array.isArray(response?.data) ? response.data : [];
        this.retailersByZone[cacheKey] = retailers.map((item: any) => ({
          _id: item._id,
          name: item.name,
        }));
      },
      error: () => {
        this.retailersByZone[cacheKey] = [];
      }
    });
  }

  onRetailerSelect(event: any, item: any): void {
    item.retailer = event ? [event] : [];
    item.retailerId = event?._id || '';
    item.retailerName = event?.name || '';
    this.refreshRelevantOptionsForKitchenScope();
  }

  getRetailersByZone(zoneId: string): any[] {
    const cacheKey = this.getRetailerCacheKey(zoneId);
    return this.retailersByZone[cacheKey] || [];
  }

  addProduct(valid) {
    if (this.model.sellingPrice < 0 || this.model.discount < 0) {
      this.toastr.error("Check discount and Selling price once", '', {
        timeOut: 3000,
      });
      return;
    }
    if (valid) {
      let body: any = {};
      body = { ...this.model };
      body.name = this.toLocalizedString(this.model.name);
      body.description = this.toLocalizedString(this.model.description);

      body.status = this.cmnService.getStatusValue(this.model.status);

      const productZones = this.formattedZoneData([...this.selectedZoneListData, ...this.previousSelectedZoneData]);
      if (!this.isZoneDataValid) return;
      if (!productZones.length) {
        this.toastr.error('At least one zone-retailer mapping is required.', '', {
          timeOut: 3000,
        });
        return;
      }

      if (this.model.discorselling === 'selling' && this.model.mrpPrice < this.model.sellingPrice) {
        this.toastr.error('MRP price should be greater than Selling price', '', {
          timeOut: 3000,
        });
        return;
      }

      body.category = this.model.category?.[0]?._id ?? this.model.category?.[0];
      body.mainCategory = this.model.mainCategory?.[0]?._id ?? this.model.mainCategory?.[0];
      body.subCategory = this.model.subCategory?.[0]?._id ?? this.model.subCategory?.[0];

      body.brand = '';
      for (let i = 0; i < this.model.selectedBrand.length; i++) {
        const element = this.model.selectedBrand[i];
        body.brand = element.name;
      }

      let tempImages = [];
      for (let i = 0; i < this.imageUrls.length; i++) {
        const element = this.imageUrls[i];
        tempImages.push(element.image);
      }
      body.imageUrl = tempImages;

      if (this.showDiscount) {
        delete body.sellingPrice;
      } else {
        delete body.discount;
      }

      if (this.isInventoryAlertsEnabled) {
        body.alerts = [
          {
            type: 'min-quantity',
            value: this.model.minQty.sort((a, b) => b - a)
          },
          {
            type: 'min-expiry-date',
            value: this.model.minExpiryDate.sort((a, b) => b - a)
          },
        ];
      }


      if (body.discorselling === 'disc') {
        delete body.sellingPrice;
      } else {
        delete body.discount;
      }
      if (!this.isFoodClassificationEnabled || body.type !== 'kitchen') {
        delete body.foodClassType;
        delete body.foodClassTaste;
      }
      if (body.type !== 'rental') {
        delete body.rentalPeriodValue;
        delete body.rentalPeriodUnit;
        delete body.rentalSecurityDeposit;
      } else {
        body.rentalPeriodValue = Number(body.rentalPeriodValue || 0);
        body.rentalSecurityDeposit = Number(body.rentalSecurityDeposit || 0);
      }

      delete body.selectedTag;
      delete body.selectedBrand;
      delete body.selectedZone;
      delete body.tags;
      delete body.discorselling;
      delete body.inHouseProduct;
      delete body.rakemartId;
      delete body.minQty;
      delete body.minExpiryDate;

      const payload = {
        product: body,
        productZones
      }

      this.loadingBarRef.start();
      this.showLoader = true;
      if (this.isEditPage) {
        let parameter: any = {
          methodType: "PUT",
        }

        this.apiService.updateProduct(parameter, payload).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.toastr.success(response.message, '', {
                timeOut: 3000,
              });
              this.router.navigateByUrl('/product/all');


            } else {
              this.toastr.error(response.message, '', {
                timeOut: 3000,
              });
            }
            this.showLoader = false;
            this.loadingBarRef.complete();

          },
          error: (error) => {
            this.toastr.error(error.message, '', {
              timeOut: 3000,
            });
            this.showLoader = false;
            this.loadingBarRef.complete();
          }
        });
      } else {
        let parameter: any = {
          methodType: "POST",
        }
        this.apiService.addProductAPI(parameter, payload).subscribe((response: any) => {
          if (response.success) {
            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.router.navigateByUrl('/product/all');

          } else {
            this.toastr.error(response.message, '', {
              timeOut: 3000,
            });
          }
          this.showLoader = false;
          this.loadingBarRef.complete();
        }, (error) => {
          this.toastr.error(error.message, '', {
            timeOut: 3000,
          });
          this.showLoader = false;
          this.loadingBarRef.complete();
        });
      }

    }

  }
}
